import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from './styles.js';
const VideoReview = ({ title, bgClr, spacing, details }) => {
  return (
    <>
      <div className={spacing ? 'pt-6' : 'pt-12'} style={{ backgroundColor: bgClr }}>
        {bgClr == '#171717' || bgClr == 'black' || bgClr == '#161616' ? (
          <HeadingSection title={title} bgcolor="black" />
        ) : (
          <HeadingSection title={title} bgcolor="white" />
        )}
        <div className="lg:container px-1 lg:px-0 mx-auto pb-4 md:pb-6">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-x-12 py-4">
            <div  style={{minHeight:"333px"}} className="w-full h-full ">
              
                
                  <iframe
                    src="https://www.youtube.com/embed/co7TdRsbIn0"
                    height="100%"
                    width="100%"
                    title="YouTube video"
                    allowFullScreen></iframe>
                
              
            </div>
            {bgClr == '#171717' || bgClr == 'black' || bgClr == '#161616' ? (
              <div style={{minHeight:"333px"}} className=" flex justify-center items-center   ">
                <p className="fs-24-36 fw-400 " style={{ fontFamily: 'Josefin Sans', color: '#A4A4A4' }}>
                  {details}
                </p>
              </div>
            ) : (
              <div  style={{minHeight:"333px"}} className=" flex justify-center items-center   ">
                <p className="fs-24-36 fw-400 " style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
                  You can spend the next minute or so to know what makes SoulRooms the right choice for hundreds of
                  young professionals across the city or fill the above form to see your options right away.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default VideoReview;
